import {
  addToJobQueue,
  clearJobQueue,
  disableNavBarAndSideBar,
  showGlobalAlert,
  showInlineAlert,
} from "slices/app/appSlice";
import localhost, { downloadFileFromResponse } from "apis/localhost";
import { modalTypes } from "constants/types";
import { showErrorModal } from "slices/app/actions/error";
import { getErrorMessage } from "utils";
import { alertVariants } from "@visiblethread/react-components/dist/components/Alert";
import { hideModal } from "slices/app/actions/modals";
import {
  cancelEdits,
  setEditMode,
  setIgnoreList,
  setLocked,
} from "slices/settings/slices/acronymIgnoreSlice";

export const cancelChanges = () => (dispatch) => {
  dispatch(cancelEdits());
  dispatch(setEditMode(false));
  dispatch(disableNavBarAndSideBar(false));
};

export const fetchAcronymIgnoreList = () => async (dispatch) => {
  dispatch(addToJobQueue("genericJob"));

  await localhost
    .get("/docs/acronymIgnoreList/")
    .then((response) => {
      const { data } = response;
      dispatch(setIgnoreList(data));
    })
    .catch((error) => {
      dispatch(showErrorModal(error));
    })
    .finally(() => {
      dispatch(clearJobQueue());
    });
};

export const openEditMode = () => async (dispatch) => {
  dispatch(addToJobQueue("genericJob"));

  await localhost
    .get("/docs/acronymIgnoreList/lock")
    .then(() => {
      dispatch(setEditMode(true));
      dispatch(disableNavBarAndSideBar(true));
    })
    .catch((error) => {
      const message = error.response.data.error;
      if (message.includes("is currently editing it")) {
        dispatch(setLocked(true));
        dispatch(
          showInlineAlert({ variant: alertVariants.warning, text: message })
        );
      } else {
        dispatch(showErrorModal(error));
      }
    })
    .finally(() => {
      dispatch(clearJobQueue());
    });
};

export const closeEditMode = () => async (dispatch) => {
  dispatch(addToJobQueue("genericJob"));

  await localhost
    .get("/docs/acronymIgnoreList/unlock")
    .then(() => {
      dispatch(cancelChanges());
    })
    .catch((error) => {
      dispatch(showErrorModal(error));
    })
    .finally(() => {
      dispatch(clearJobQueue());
    });
};

export const setAcronymIgnoreList = (ignoreList) => async (dispatch) => {
  dispatch(addToJobQueue("genericJob"));

  await localhost
    .post(
      "/docs/acronymIgnoreList/edit/",
      ignoreList
        .filter((ignoreListItem) => ignoreListItem.term)
        .map((ignoreListItem) => ({
          ignoreWord: ignoreListItem.term,
          regex: ignoreListItem.regex,
        }))
    )
    .then((response) => {
      const { data } = response;
      dispatch(setIgnoreList(data));
      dispatch(setEditMode(false));
      dispatch(disableNavBarAndSideBar(false));
    })
    .catch((error) => {
      dispatch(showErrorModal(error));
    })
    .finally(() => {
      dispatch(clearJobQueue());
    });
};

export const exportAcronymIgnoreList = () => async (dispatch) => {
  dispatch(addToJobQueue("genericJob"));

  await localhost
    .get("/docs/acronymIgnoreList/export/", {
      responseType: "blob",
    })
    .then(async (response) => {
      const { data } = response;
      downloadFileFromResponse(data, "Acronym Ignore List.csv");
    })
    .catch(async (error) => {
      dispatch(showErrorModal(error));
    })
    .finally(() => {
      dispatch(clearJobQueue());
    });
};

export const importAcronymIgnoreList = (formData) => async (dispatch) => {
  dispatch(addToJobQueue("genericJob"));

  await localhost
    .post("/docs/acronymIgnoreList/import/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      const { data } = response;
      dispatch(setIgnoreList(data));
      dispatch(
        showGlobalAlert({
          variant: alertVariants.success,
          text: `"${formData.get("importedFile").name}" imported successfully`,
        })
      );
    })
    .catch((error) => {
      dispatch(
        showGlobalAlert({
          variant: alertVariants.danger,
          text: getErrorMessage(error),
        })
      );
    })
    .finally(() => {
      dispatch(hideModal(modalTypes.IMPORT_FILE));
      dispatch(clearJobQueue());
    });
};
